import React from 'react'
import {Text,Box, DateInput, TextInput, FormField,Form, Button,CheckBox,Select,Tip,Card} from 'grommet'
import {DocumentUpload, FormSubtract,Add,Launch,Cube,Notes,FormClock,Deliver, ScheduleNew,Location, Alert,Save} from 'grommet-icons';
import CommoditiesDropdown from './commoditiesDropdown';
import { withRouter } from 'react-router-dom';
import { ReturnRowDir,ShipmentDetailForm } from './utils/shared/shared';
import moment from 'moment'

function ShipmentPieceInformation(props){
   
   function validatePiecesReady(e, type){
      if (type === 'object'){
         Object.values(e).forEach(function(val) {
            if (val === ''){
               props.setPiecesReady(false)
            } else {
               props.setPiecesReady(true)
            }
         })
      } else {
         if (e.valid){
            props.setPiecesReady(true)
         } else {
            props.setPiecesReady(false)
         }
      }
   }


   return (
      <Card margin='small' justify='center' align='center' elevation='large' round background='background-front'>
       <Text alignSelf='start' margin='medium' weight='bold'><Cube color='status-ok'style={{marginRight: 5}}/>Parcel Details</Text>
      <Box direction={ReturnRowDir(props.props.size)} justify="center" flex="grow">
      <Box direction='column' justify="center">
      {props.props.shipmentPieceDetails.map((x, i) => {
         return(
               <Form value={x} onChange={nextValue => {props.props.handlePieceDetails(nextValue, i); validatePiecesReady(nextValue, 'object')}} validate='change' onValidate={(e) => {validatePiecesReady(e, 'event');}}>               <Box direction={ReturnRowDir(props.props.size)} justify='start' flex='shrink'>
                  {ShipmentDetailForm.map(item => {
                     if (item.name === 'commodity'){
                        return (
                           <CommoditiesDropdown commodity={x.commodity} props={props}  />
                        )
                     } else {
                        return (
                           <FormField required name={item.name}  width='small' label={<Text size='small'>{item.label}</Text>}  margin='small'>
                              <TextInput size='small' min={item.min} name={item.name} icon={item.icon} placeholder={item.placeholder} type={item.type}/>
                           </FormField>
                        )
                     }
                     
                  })}
                     {(i > 0 ? <Button margin='small' hoverIndicator icon={<FormSubtract color='status-critical' />} onClick={() => {props.props.handleRemovePiece(i)}} color='brand'/> : <div style={{marginLeft:50}}></div>)}
                     <Button margin='small' hoverIndicator icon={<Add color='brand'/>} onClick={() => {props.props.handleAddPiece()}} color='brand'/>
               </Box>
            </Form>
         )
      })}
      </Box>
      </Box>
      {((props.piecesReady === false ? <Text alignSelf='start' margin='medium' size='small' weight='bold' color='status-critical'>Please ensure all fields are completed and correct before proceeding.</Text> : null ))}
   </Card>
   )
}

function returnCustomerPOName(user){
   if(user === 'Agent'){
      return "Vessel Name"
   } else {
      return "Customer PO Number"
   }
}

function returnCustomerPOPlaceHolder(user){
   if(user === 'Agent'){
      return "Enter Vessel Name..."
   } else {
      return "Enter Customer PO..."
   }
}

function ShipmentCollectionDetails(props){
   return (
      <Card margin='small' elevation='medium' round background='background-front'>
        <Text alignSelf='start' margin='medium' weight='bold'><ScheduleNew color='status-ok'style={{marginRight: 5}}/>Collection Details</Text>
      <Box direction='row' justify="start">
         <FormField size='xsmall' name="requestPickup" margin='small'>
            <CheckBox size={'small'} name='requestPickup'  label={<Text size='small'>Request Pickup</Text>}  icon={<Deliver />}/>
            </FormField>
            <FormField name="collectionDate" label={<Text size='small'>Collection Date</Text>}  required margin='small'>
               <DateInput calendarProps={{daysOfWeek: true}} size={'small'} firstDayOfWeek={1} name="collectionDate" format="dd/mm/yyyy" label="Collection Date"/>
               </FormField>
               <FormField name="collectionTime" label={<Text size='small'>Collection Time</Text>}  required margin='small'
                validate={((collectionTime, details) => {
                  var collectionDate = moment(details.collectionDate).format("YYYY-MM-DD")
                  var openTime = moment(collectionTime, "HH:mm").format("HH:mm")
                  var open = moment(collectionDate + openTime, "YYYY-MM-DDHH:mm")
                  var now = moment()
                  var duration = open.isBefore(now)
                  if (duration){
                     return <Text size='xsmall' color={'status-critical'}>Please select a valid Collection Time.</Text>
                  }
               })}>
                  <TextInput size='small' name="collectionTime" type='time'  icon={<FormClock />}/>
               </FormField>
               <FormField name="pickupCloseTime" label={<Text size='small'>Closing Time</Text>}  required margin='small'
                  validate={((pickupCloseTime, details) => {
                     var open = moment(details.collectionTime,'HH:mm:ss a')
                     var close = moment(pickupCloseTime,'HH:mm:ss a')
                     var duration = moment.duration(close.diff(open));
                     var hours = parseInt(duration.asHours());
                     if (hours < 2 && details.requestPickup){
                        return <Text size='xsmall' color={'status-critical'}>Minimum 2 hour interval required</Text>
                     }
                  })}
               >
                  <TextInput size='small' name="pickupCloseTime" type='time'  icon={<FormClock />}/>
               </FormField>
               <FormField name="pickupLocation" label={<Text size='small'>Pickup Location</Text>}  required margin='small' info={<Text size='xsmall' color='text-xweak'>Where should your package be collected from?</Text>}>
               <Select
               name="pickupLocation"
               size='small'
                  icon={<Location />}
                  placeholder="Pickup Location"
                  options={['Front Desk', 'Reception', 'Warehouse', 'Office', 'Front Door']}
               />
               </FormField>
               <FormField name="customerPO" validate={{regexp:/^[\S\s/A-Z+a-z/().,;:0-9+=_-]{0,30}$/, message: "Field must be less than 30 characters."}} label={<Text size='small'>{returnCustomerPOName(props.props.user)}</Text>} required margin='small' >
                  <TextInput size='small' icon={<Notes />}name="customerPO" placeholder={returnCustomerPOPlaceHolder(props.props.user)}/>
               </FormField>
            </Box>
         </Card>
   )
}

function finalValidation(shipmentPieceDetails, setPiecesReady){
   let valid; 
   Object.values(shipmentPieceDetails).forEach(piece => {
      if (JSON.stringify(piece.commodity) === "{}"){
         valid = false
      } else {
         valid = true
      }
   })
  setPiecesReady(valid)
}

function ShipmentDetailsForm(props){
   const termsOfTradeOptions = [{label: 'Duties and Taxes Unpaid', value: 'DAP'},{label: 'Duties and Taxes Paid', value: 'DDP'}]
   const [termsOfTrade, setTermsOfTrade] = React.useState({label: 'Duties and Taxes Unpaid', value: 'DAP'})
   const [piecesReady, setPiecesReady] = React.useState(false)
   const value = props.value
  
    let termsOfTradeSelect;
    let reqButton;
    if(props.value.dg){
       reqButton = <Box><Box direction={ReturnRowDir(props.size)}><Box background={'status-critical'} round margin={'small'} pad='small'><Box direction='row'><Alert /><Text weight='bold' margin={{left:'small'}}>This shipment contains Dangerous Goods. Please finish the shipment details, attach the MSDS and click Save.</Text></Box><Text justify='center' alignSelf='center' weight={'bold'} margin={{left:'small'}}> A member of a our team will make contact shortly to process your request.</Text></Box><FormField name='dgMsds' label='MSDS Document' margin='small' > <TextInput icon={<DocumentUpload/>}type="file" onChange={props.handleDocsChange} /> </FormField></Box><Button style={{maxWidth:250}} margin='small'primary label="Save Shipment" type='submit' icon={<Save />}/></Box>
    } else {
       reqButton = <Button hoverIndicator onClick={() => {finalValidation(props.shipmentPieceDetails, setPiecesReady)}} margin='small'primary label="Create Shipment" type='submit' icon={<Launch />}/>
    }
      
    function sendParametersToParent(param, shipmentDetails){
        props.shipmentDetails(param,props.shipmentPieceDetails,props.origin.country.CountryCode)
    }
    sendParametersToParent(value, props.shipmentPieceDetails)
    if (props.lab && props.lab[0].display_terms_of_trade){
       termsOfTradeSelect = (
          <Card margin='small' elevation='large' round background='background-front' >
            <Tip plain content={
                     <Box pad="small" gap="small" width={{ max: 'large' }} round background="background-front">
                        <Box direction='row' justify='between'><Alert color='status-critical'/><Text weight="bold">Selecting Shipment Terms of Trade</Text><Alert color='status-critical'/></Box>
                        <Text size="small"><strong>Duties and Taxes Unpaid (DAP)</strong> will result in the reciever paying any applicable duties or taxes before the shipment is delivered.</Text>
                        <Text size='small'><strong>Duties and Taxes Paid (DDP)</strong> will result in Sample Logistics paying any applicable duties and taxes upfront on your behalf and invoicing you once the shipment is delivered. Please note this service will cost an additional $36 USD plus the duties and taxes cost to your shipment. </Text>
                     </Box>
                  }
                  dropProps={{ align: { bottom:'right' } }}
                  >
            <FormField width='medium'  alignSelf='center'  required label={<Text size='small'>Shipment Terms of Trade</Text>} name='termsOfTrade' margin='small' >
               <Select  width='medium' value={termsOfTrade} name="termsOfTrade" placeholder="Select Terms of Trade" labelKey="label" valueKey={{ key: 'value', reduce: true }} options={termsOfTradeOptions} onChange={({value: nextValue }) => setTermsOfTrade(nextValue)}/>
            </FormField>
         </Tip>
         </Card>
       )
    }
    function submitShipmentDetails(){
      if (props.value.dg){
          props.handleSubmit()
      } else {
         if (piecesReady){
            props.setShowLayer(true)
         }
      }
    }


    return (
       <Box>
          <Form value={props.value} onSubmit={submitShipmentDetails} onChange={nextValue => props.handleValueChange(nextValue)} >
               <ShipmentCollectionDetails props={props} />
                  <ShipmentPieceInformation props={props} setPiecesReady={setPiecesReady} piecesReady={piecesReady} />
                  <Box direction={ReturnRowDir(props.size)} justify='start'>
                  {termsOfTradeSelect}
                  <Box background='background-front' style={{verticalAlign: 'middle'}} round elevation='large' margin='small' height='xsmall' justify='center'>
                  <Tip plain content={
                        <Box margin='medium' pad="small" gap="small" width={{ max: 'large' }} round background="background-back">
                           <Box direction='row' justify='between'><Alert color='status-critical'/><Text weight="bold">Sending Dangerous Goods?</Text><Alert color='status-critical'/></Box>
                           <Text size="small">Dangerous goods are items that are highly corrosive or flammable, with a flashpoint below 60.5 degrees celsius.</Text>
                           <Text size='small'>If you are unsure, please tick this box and we will assess your shipment.</Text>
                        </Box>
                     }
                     dropProps={{ align: { bottom: 'left' } }}
                     >
                  <Box margin='small' justify='center'alignSelf='center'>
                  <FormField name='dg' label={<Text size='small' weight='bold'>Does this shipment contain Dangerous Goods?</Text>}><CheckBox name='dg' margin='small' /></FormField>
                  </Box>
                  </Tip>
                  </Box>  
               </Box>
               <Box direction='row' justify="start" margin={{top: 'small'}}>
                  {reqButton}
               </Box>
             </Form>
             </Box>
      )
}


export default withRouter(ShipmentDetailsForm)
